import { render } from "./FeederPillarModal.vue?vue&type=template&id=340a860e&scoped=true"
import script from "./FeederPillarModal.vue?vue&type=script&lang=js"
export * from "./FeederPillarModal.vue?vue&type=script&lang=js"

import "./FeederPillarModal.vue?vue&type=style&index=0&id=340a860e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-340a860e"]])

export default __exports__